import { detailsBigCss, h2, h4, paragraphSmallCss } from "@/styles/typography";
import styled from "styled-components";

const BlogWrapper = styled.div`
  a.anchor {
    display: block;
    position: relative;
    top: -70px;
    visibility: hidden;
  }

  ul {
    width: 100%;
    a {
      margin-bottom: 100px;
      ${detailsBigCss}
      border: none;
      background-color: transparent;
      cursor: pointer;
      color: ${({ theme }) => theme.colors.primary};
      list-style: none;
      transition: all 0.3s;
      border-bottom: 2px solid transparent;

      text-decoration: none;
      margin-right: 50px;

      &:hover {
        border-bottom: 5px solid ${({ theme }) => theme.colors.primary};
      }
      @media ${({ theme }) => theme.breakpoints.md} {
        margin-right: 20px;
      }
      .active-link {
        border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
        color: red;
      }
    }
  }

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const ActiveLink = styled.a`
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
`;

const NoContentMessage = styled(h4)`
  color: #124d60;
  margin-bottom: 5rem;
  text-transform: none;
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  margin-bottom: 70px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  transition: all 0.3s ease-in-out;

  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: repeat(auto-fit, minmax(min(415px, 100%), 1fr));
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: right;
  transform: translateY(-120px);

  a {
    margin-top: 100px;
  }
`;

const LatestContainer = styled.div`
  height: 100%;
  width: 100%;
  margin-bottom: 20px;
  transition: all 0.3s ease-in-out;
`;

const UlWrapper = styled.div`
  width: 100%;
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: row;
`;

const SearchBarWrapper = styled.div`
  position: relative;
  height: 50px;
  width: 435px;

  @media (max-width: 1020px) {
    width: 300px;
  }
`;

const Search = styled.input`
  ${paragraphSmallCss}

  width: 435px;
  padding: 0 20px;
  height: 50px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  max-width: 100%;
  transition: all 0.3s ease-in-out;

  @media (max-width: 1020px) {
    width: 300px;
  }
`;

const SearchIcon = styled.img`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 22px;
`;

const Title = styled(h2)`
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 50px;
  text-transform: uppercase;
  width: fit-content;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-bottom: 32px;
  }
`;

const Line = styled.div`
  margin-top: 30px;
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.colors.primary};
`;

const ReadMoreButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 48px 16px 48px;
  gap: 24px;
  background-color: transparent;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  ${detailsBigCss}
  margin: 0 auto 70px auto;
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.textColors.secondary};
    }
  }
`;

const S = {
  BlogWrapper,
  Container,
  ButtonWrapper,
  LatestContainer,
  UlWrapper,
  Ul,
  ActiveLink,
  SearchBarWrapper,
  Search,
  SearchIcon,
  Title,
  Line,
  ReadMoreButton,
  NoContentMessage
};

export default S;
